// API related actions
export const FETCHING_DAILY_VEHICLES_SALES_SUMMARY = '@@toyota/FETCHING_DAILY_VEHICLES_SALES_SUMMARY';
export const FETCHED_DAILY_VEHICLES_SALES_SUMMARY = '@@toyota/FETCHED_DAILY_VEHICLES_SALES_SUMMARY';
export const FETCHED_DAILY_VEHICLES_SALES_SUMMARY_FAILED = '@@toyota/FETCHED_DAILY_VEHICLES_SALES_SUMMARY_FAILED';
export const DOWNLOADING_DAILY_VEHICLES_SALES_SUMMARY = '@@toyota/DOWNLOADING_DAILY_VEHICLES_SALES_SUMMARY';
export const DOWNLOADED_DAILY_VEHICLES_SALES_SUMMARY = '@@toyota/DOWNLOADED_DAILY_VEHICLES_SALES_SUMMARY';
export const DOWNLOADED_DAILY_VEHICLES_SALES_SUMMARY_FAILED = '@@toyota/DOWNLOADED_DAILY_VEHICLES_SALES_SUMMARY_FAILED';
